import {useEffect} from "react";

const hideEl = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.style.display = "none";
  return el;
};

const useHideSupportChat = (dontHide?: boolean) => {
  useEffect(() => {
    if (dontHide) return;

    const chat = hideEl("fd-chat-client-v2");
    hideEl("ak-help-root");

    const observer = new MutationObserver(() => {
      hideEl("fd-chat-client-v2");
      hideEl("ak-help-root");
    });

    if (chat) observer.observe(chat, {attributes: true, attributeFilter: ["style"]});

    return () => {
      const restoredChat = document.getElementById("fd-chat-client-v2");
      if (restoredChat) restoredChat.style.display = "block";
      const restoredHelp = document.getElementById("ak-help-root");
      if (restoredHelp) restoredHelp.style.display = "block";
      observer.disconnect();
    };
  }, [dontHide]);
};

export default useHideSupportChat;
